const RUC_EXPLOMIN = "20501523837";

export const aplicaAgrupacionOnboarding = (usuario) => usuario?.empresaSeleccionada?.ruc === RUC_EXPLOMIN;

/**
 * Agrupa los documentos por onboarding (manteniendo el orden de aparicion).
 * Los documentos sin onboarding quedan al final, en un grupo "Otros documentos pendientes".
 */
export const agruparPorOnboarding = (documentos = []) => {
	const grupos = [];
	const indicePorOnboarding = {};
	const sueltos = [];

	documentos.forEach((documento) => {
		if (!documento.onboardingId || !documento.onboardingNombre) {
			sueltos.push(documento);
			return;
		}
		if (indicePorOnboarding[documento.onboardingId] === undefined) {
			indicePorOnboarding[documento.onboardingId] = grupos.length;
			grupos.push({ id: documento.onboardingId, nombre: documento.onboardingNombre, documentos: [] });
		}
		grupos[indicePorOnboarding[documento.onboardingId]].documentos.push(documento);
	});

	if (sueltos.length > 0) {
		grupos.push({ id: "sin-onboarding", nombre: "Otros documentos pendientes", documentos: sueltos });
	}
	return grupos;
};
